<!-- 没有数据显示模块
     status: 1  酒瓶子
             2  收货地址
             3  拍品（每日一拍）
             4  网络异常
             5  搜索无结果
             6  系统信息

     top:  用于调整图片与文字的高度位置，默认为-3rem

 -->
<template>
<div class="noData rich-view">
  <div :style="{marginTop: top?top:'-3rem'}">
    <img :src="imagePath" :style="{width:(status==1||!status)?'1rem':'3.2rem'}"/>
    <div class="text-color-help fs16">{{newMessage}}</div>
    <p class="remarkMessage">{{subMessage}}</p>
    <button class="noDataBtn" v-if="status==4">重新加载</button>
    <button class="addressNoData fs16" v-if="status==2">+ 添加</button>
  </div>
</div>
</template>
<script>
export default {
    name: 'noData',
    props: ["status","message","top", "subTitle"],
    data() {
        return {
          imagePath: require('../../assets/static/no-data.png'),
          newMessage: '',
          subMessage: ''
        }
    },
  mounted() {
      if (this.status == 1 || !this.status) {
        this.imagePath = require('../../assets/static/sousuo_54@2x.png');
        if (!this.message) {
          this.newMessage = "暂无结果";
        }
      } else if (this.status == 2) {
        this.imagePath = require('../../assets/static/dingdan_53@2x.png');
        if (!this.message) {
          this.newMessage = "暂无信息";
        }
        this.subMessage = "赶紧添加收货人信息吧"
      } else if (this.status == 3) {
        this.imagePath = require('../../assets/static/auctionItems.png');
        if (!this.message) {
          this.newMessage = "敬请期待";
        }
        this.subMessage = this.subTitle || "拍品正在筹备中"
      } else if (this.status == 4) {
        this.imagePath = require('../../assets/static/wuwangluo_51@2x.png');
        if (!this.message) {
          this.newMessage = "网络异常";
        }
        this.subMessage = "试试检查网络再重新加载"
      } else if (this.status == 5) {
        this.imagePath = require('../../assets/static/sousuo_54@2x.png');
        if (!this.message) {
          this.newMessage = "暂无结果";
        }
        this.subMessage = "换个关键词试试看"
      } else if (this.status == 6) {
        this.imagePath = require('../../assets/static/systemInfo.png');
        if (!this.message) {
          this.newMessage = "暂无数据";
        }
      }else if (this.status == 7) {
        this.imagePath = require('../../assets/static/dingdan_53@2x.png');
        if (!this.message) {
          this.newMessage = "暂无数据";
        }
      }else if (this.status == 10) {
        // this.imagePath = require('../../pages/error/img/error.png');
        // if (!this.message) {
        //   this.newMessage = "网络错误";
        // }
      }
      if (this.message) {
        this.newMessage = this.message;
      }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .rich-view {
    overflow-y: auto;
  }
.noData{
	/*height: 8rem;*/
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
  text-align: center;
	width: 100%;
  img{
      width: 3.2rem;
      margin-bottom: .42rem;
  }
  .remarkMessage {
    margin-top: .1rem;
    margin-bottom: .4rem;
    color: #CCCCCC;
  }
  .noDataBtn {
    border: 0.5px solid #282828;
    width: 1.92rem;
    height: .64rem;
    color: #282828;
  }
  .addressNoData {
    border: 0.5px solid #282828;
    width: 2rem;
    height: .72rem;
    color: #282828;
  }
}
.box-just{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -o-box;
    display: box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
}
.box-center {
    -ms-flex-align: center;
    align-items: center;
    box-align: center;
    -webkit-box-align: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -webkit-box-pack: center;
}
.text-color-help{
    color: #979797;
}


</style>



// WEBPACK FOOTER //
// src/components/common/noData.vue